import { createFileRoute } from "@tanstack/react-router";
import { MacroBuilderView } from "@/components/views/builder/MacroBuilderView";

export const Route = createFileRoute("/builder")({
  component: () => <MacroBuilderView />,
});
